import React, { memo } from 'react'
import { faMusic, faVideo } from '@fortawesome/pro-duotone-svg-icons'

import { isMediaTypeAudio } from '../../../util/media.helpers'
import FaIcon from '../faIcon/FaIcon'

const NftIcon = ({ metadata }) => {
  const mediaType = metadata?.media?.type
  if (!mediaType) {
    return null
  }
  return (
    <FaIcon icon={isMediaTypeAudio(mediaType) ? faMusic : faVideo} size='6x' />
  )
}

export default memo(NftIcon)
